module.exports = __webpack_public_path__ + "img/we-got-a-problem-dark.bef707e8.svg";